import React from 'react';
import { defineMessages, FormattedMessage } from 'react-intl';
import { StyleSheet } from 'react-native';
import { BodyText } from '@sg/garnish';

export const BagAnimatedDialogTitle = (props: BagAnimatedDialogTitleProps) => {
  const {
    isShowingCheckoutLedger,
    isChangingTime,
    isChangingDeliveryPreferences,
    isChangingPaymentMethod,
    isShowingPaymentMethodForm,
    isShowingGiftCardForm,
  } = props;

  return (
    <>
      {isShowingCheckoutLedger ? (
        <BodyText style={styles.title} sizeMatch={TEXT_SIZE}>
          <FormattedMessage {...messages.checkout} />
        </BodyText>
      ) : null}

      {isChangingTime ? (
        <BodyText style={styles.title} sizeMatch={TEXT_SIZE}>
          <FormattedMessage {...messages.chooseTime} />
        </BodyText>
      ) : null}

      {isChangingDeliveryPreferences ? (
        <BodyText style={styles.title} sizeMatch={TEXT_SIZE}>
          <FormattedMessage {...messages.editDeliveryPreferences} />
        </BodyText>
      ) : null}

      {isChangingPaymentMethod ? (
        <BodyText style={styles.title} sizeMatch={TEXT_SIZE}>
          <FormattedMessage {...messages.selectPaymentOption} />
        </BodyText>
      ) : null}

      {isShowingPaymentMethodForm ? (
        <BodyText style={styles.title} sizeMatch={TEXT_SIZE}>
          <FormattedMessage {...messages.addCard} />
        </BodyText>
      ) : null}

      {isShowingGiftCardForm ? (
        <BodyText style={styles.title} sizeMatch={TEXT_SIZE}>
          <FormattedMessage {...messages.redeemGiftCard} />
        </BodyText>
      ) : null}
    </>
  );
};

// ─── Constants ──────────────────────────────────────────────────────────────

const TEXT_SIZE = ['22' as const];

// ─── Styles ─────────────────────────────────────────────────────────────────

const styles = StyleSheet.create({
  title: {
    textAlign: 'center',
  },
});

// ─── Messages ───────────────────────────────────────────────────────────────

const messages = defineMessages({
  addCard: {
    defaultMessage: 'Add card',
    description: 'Checkout | Add card | Title',
  },
  checkout: {
    defaultMessage: 'Checkout',
    description: 'Checkout | Checkout | Title',
  },
  chooseTime: {
    defaultMessage: 'Time',
    description: 'Checkout | Choose a time | Title',
  },
  editDeliveryPreferences: {
    defaultMessage: 'Delivery',
    description: 'Checkout | Edit delivery preferences | Title',
  },
  selectPaymentOption: {
    defaultMessage: 'Payments',
    description: 'Checkout | Select payment option | Title',
  },
  redeemGiftCard: {
    defaultMessage: 'Redeem',
    description: 'Checkout | Redeem gift card | Title',
  },
});

// ─── Types ──────────────────────────────────────────────────────────────────

type BagAnimatedDialogTitleProps = {
  isShowingCheckoutLedger: boolean;
  isChangingTime: boolean;
  isChangingDeliveryPreferences: boolean;
  isChangingPaymentMethod: boolean;
  isShowingPaymentMethodForm: boolean;
  isShowingGiftCardForm: boolean;
};
